import MicroModal from "micromodal";

const ModalThumb = (props) => {
  const { nombreModal, thumb } = props;

  const cerrarModal = () => {
    MicroModal.close(nombreModal, {
      awaitCloseAnimation: true
    });
  }
  
  return (
    <div className="micromodal-slide" id={nombreModal} aria-hidden="true">
      <div className="modal__overlay">
        <div className="modal__container m-8 md:m-0" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <button className="modal__cerrar icon-cerrar " onClick={cerrarModal}></button>
          <img src={require(`../../images/ilustraciones/${thumb}`).default} alt="ilustración de la historia" />
        </div>
      </div>
    </div>
  )
}

export default ModalThumb;